const TEXT = {
  EDIT_FILTER: 'Edit Filter',
  REMOVE_ALL: 'Remove All',
  MORE_FILTERS: 'More Filters',
  REGULATION_OPTIN_HEADER: 'Regulation-wise Opt-in',
  REGULATION_TRAFFIC_HEADER: 'Regulation-wise Traffic',
  PAGE_SESSIONS_HEADER: 'Page-wise display count',
  REGION_TRAFFIC_HEADER: 'Region-wise Traffic',
  GDPR_CONSENT_HEADER: 'GDPR Consent Distribution',
  CCPA_CONSENT_HEADER: 'CCPA Consent Distribution',
  SUMMARY: 'Summary',
  COMPARE: 'compared to',
  FILTER: 'Filter your',
  DASHBOARD: 'Dashboard',
  REGULATION: 'Regulation',
  FILTERS: 'Filters',
  PAGES: 'Pages',
  DEVICE_TYPE: 'Device Type',
  OS: 'OS',
  COUNTRIES: 'Countries',
  CANCEL: 'Cancel',
  APPLY_FILTER: 'Apply Filter ',
  NO_CHANGE: 'No Change',
  TABLE_HEADER: 'Traffic & Consent by Countries',
  TABLE_SUB_TEXT: 'in comparison to',
  NO_DATA_LINE1: 'It looks like no properties have been selected.',
  NO_DATA_LINE2: 'Select a property to see detailed insights and metrics.'
};

export default TEXT;
